import React from 'react';
import Back from '../../components/Back';
import {useMutation, useQuery} from '@apollo/client';
import {MUTATION_CONTEST_CLIENT_SAVE, QUERY_CONTEST_CLIENT_LIST, QUERY_CONTEST_DETAIL} from './graphql';
import Query from '../../components/Query';
import {updateCreate} from '../../utils/mutation';
import ContestClient from './Client';
import moment from 'moment';
import { QUERY_USER } from '../Client/graphql';
import { isActive } from '../Client/utils';
import { Link } from 'react-router-dom/cjs/react-router-dom.min';

export const ContestDetail = ({match}) => {
  const {user} = useQuery(QUERY_USER).data;

  const query = useQuery(QUERY_CONTEST_DETAIL, {variables: {id: match.params.id}});
  const obj = query.data ? query.data.contestDetail : null;

  console.log(query);

  const {data: {contestClientList = []} = {}} = useQuery(QUERY_CONTEST_CLIENT_LIST);
  const contestClient = obj ? contestClientList.find(x => x.contestId === obj.id) : null;

  const [start] = useMutation(MUTATION_CONTEST_CLIENT_SAVE, {
    update: (cache, response) => updateCreate(cache, response, {query: QUERY_CONTEST_CLIENT_LIST}),
  });

  return (
    <div className="container py-4">
      <div className="row align-items-center g-3"> 
        <div className="col-auto">
          <Back />
        </div>
        <div className="col-auto font-4">{obj?.name}</div>
      </div>
      {!isActive(user) ? (
        <div className="text-center py-4">
          <div>Ваш аккаунт не активирован</div>
          <Link to="/payments" className="btn btn-link p-0 ms-2">
            Активировать
          </Link>
        </div>
      ) : (
        Query(query) || (
          <div>
            {contestClient ? (
              <div className="py-4">
                <ContestClient obj={contestClient} contest={obj} />
              </div>
            ) : (
              moment(obj.startTime).isAfter(moment()) ? (
                <div className="py-4 text-center">Еще не начался</div>
              ) : moment(obj.endTime).isBefore(moment()) ? (
                <div className="py-4 text-center">Тест закрыт</div>
              ) : (
                <div className="row justify-content-center py-4 text-center">
                  <div className="col-9 border bg-white">
                    <div className="p-3" style={{whiteSpace: 'pre-wrap'}}>{obj.content}</div>
                    <button 
                      onClick={() => start({variables: {input: {contest: obj.id}}})}
                      className="btn btn-primary my-3"
                    >
                      Начать
                    </button>
                  </div>
                </div>
              )
            )}
          </div>
        )
      )}
    </div>
  );
};

export default ContestDetail;
